function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.089 3.651c1.056-1.936 2.77-1.93 3.823 0l7.01 12.851c1.056 1.936.12 3.505-2.087 3.505H5.166c-2.208 0-3.14-1.575-2.087-3.505zm2.814 6.43V7.368h-1.805v2.713l.463 4.35h.868zm-.076 7.218v-1.865h-1.642v1.865z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-alert.svg";
export { SvgComponent as ReactComponent };